import React from 'react'
import ReactDom from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import store from './stores/store'
import createWarningMarkup from './util/warningMarkup'
import { isRTL } from './settings'
import { getFormMeta } from './util/formMetaDataExtractor'
import HelmetConfig from './helmet'
import AppProviders from './context'

//
// ─── INITIALIZE TOOLS ───────────────────────────────────────────────────────────
//

import preStartFuncs from './initialize'

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

// direction insensitive styles ahead!
import './styles/form-general.css'
import './styles/reset.css'
import './styles/normalType-style.css'
import './styles/form-fields-global.css'

// Caution: direction sensitive styles ahead!
const isRtl = isRTL()
export const formMetaData = getFormMeta()

if (isRtl) {
  import('./styles/styles.rtl.css')
} else {
  import('./styles/styles.ltr.css')
}

// ─── RUN PRE-START FUNCTIONS ────────────────────────────────────────────────────

const env = process.env.NODE_ENV
preStartFuncs.forEach((fn) => fn(env))

// null check for "slug" is handled by app component, so, not here.
// if there was no wrapper -> go ahead and create one
if (!formMetaData.wrapperExists) {
  createWarningMarkup(formMetaData.wrapperElementId)
} else {
  render()
}

function render() {
  ReactDom.render(
    <AppProviders formMetaData={formMetaData}>
      <Provider store={store}>
        <HelmetConfig>
          <App />
        </HelmetConfig>
      </Provider>
    </AppProviders>,
    formMetaData.wrapperElement
  )
}
